import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import CvPageLayout from '../../../components/CvPageLayout';
import DescriptionForm from '../../../components/DescriptionForm';

function CvEducationDescription() {
  const [description, setDescription] = useState([]);

  return (
    <CvPageLayout currentStep="Edukacja">
      <Row className="justify-content-md-center mt-3">
        <Col>
          <DescriptionForm
            backlink="/cv-career/cv-generator/section/education/form"
            nextlink="/cv-career/cv-generator/section/education"
            description={description}
            setDescription={setDescription}
            type="education"
          />
        </Col>
      </Row>
    </CvPageLayout>
  );
}

export default CvEducationDescription;
